import {
  PGIcon, PLIcon, WireIcon, SmartBillingIcon, InstaCollectIcon, LoansIcon, TellerIcon, AppStoreIcon, EduIcon,
  disabledWireIcon, disabledInstaCollectIcon, disabledLoansIcon, disabledPGIcon, disabledPLIcon, disabledTellerIcon, disabledSmartBillingIcon, disabledEduIcon, disabledAppStoreIcon, SmartXIcon, disabledSmartXIcon, chatIcon, redirectIcon
} from '../../../constants'
import get from 'lodash/get'
import {
  faChartBar,
  faAddressCard,
  faListAlt,
  faFileExcel,
  faFileAlt
} from "@fortawesome/free-regular-svg-icons";
import { faUniversity } from "@fortawesome/free-solid-svg-icons/faUniversity";
import { faRupeeSign } from "@fortawesome/free-solid-svg-icons/faRupeeSign";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons/faUserPlus";
import { faUserClock } from "@fortawesome/free-solid-svg-icons/faUserClock";

import { faLink } from "@fortawesome/free-solid-svg-icons/faLink";
import { faFileInvoice } from "@fortawesome/free-solid-svg-icons/faFileInvoice";
import { faCheckDouble } from "@fortawesome/free-solid-svg-icons/";
import { faCalculator } from "@fortawesome/free-solid-svg-icons/faCalculator";
import { faSitemap } from "@fortawesome/free-solid-svg-icons/faSitemap";
import { isEmpty } from "lodash";

const PRODUCT_URLS = {
  prod: {
    pg: "https://dashboard.easebuzz.in/dashboard",
    payment_link: "https://easebuzz.in/merchant/dashboard",
    wire: "https://wire.easebuzz.in/",
    insta_collect: "https://wire.easebuzz.in/insta-collect/",
    smartbilling: "https://apps.easebuzz.in/",
    // loans: "https://loans.easebuzz.in/dashboard/leads/",
    teller: "https://teller.easebuzz.in/",
    edu: "https://edu.easebuzz.in/institute/",
    appstore: "https://appstore.easebuzz.in/",
    smartx: "https://smartx.easebuzz.in/"
  },
  dev: {
    pg: "https://newdevdashboard.easebuzz.in/dashboard",
    payment_link: "https://dev.easebuzz.in/merchant/dashboard",
    wire: "https://devwire.easebuzz.in/",
    insta_collect: "https://devwire.easebuzz.in/insta-collect/",
    smartbilling: "https://devinvoice.easebuzz.in/",
    // loans: "https://devloans.easebuzz.in/dashboard/leads/",
    teller: "https://devteller.easebuzz.in/",
    edu: "https://devedu.easebuzz.in/institute/",
    appstore: "https://devapps.easebuzz.in/",
    smartx: "https://devsmartx.easebuzz.in/"
  },
  local: {
    pg: "https://newdevdashboard.easebuzz.in/dashboard",
    payment_link: "https://dev.easebuzz.in/merchant/dashboard",
    wire: "https://devwire.easebuzz.in/",
    insta_collect: "https://devwire.easebuzz.in/insta-collect/",
    smartbilling: "https://devinvoice.easebuzz.in/",
    // loans: "https://devloans.easebuzz.in/dashboard/leads/",
    teller: "https://devteller.easebuzz.in/",
    edu: "https://devedu.easebuzz.in/institute/",
    appstore: "https://devapps.easebuzz.in/",
    smartx: "https://devsmartx.easebuzz.in/",
    drs:"https://drs.easebuzz.dev/"
  }
}

const PAGE_URLS = {
  prod: {
    pg: "https://easebuzz.in/online-payment-gateway-India/",
    payment_link: "https://easebuzz.in/payment-links/",
    wire: "https://easebuzz.in/wire/",
    insta_collect: "https://easebuzz.in/insta-collect",
    edu: "https://easebuzz.in/feesbuzz/",
    smartbilling: "https://easebuzz.in/smartbilling/",
    // loans: "https://easebuzz.in/lending/",
    teller: "https://easebuzz.in/teller/",
    smartx: "https://easebuzz.in/smartx-expense-management/"
  },
  dev: {
    pg: "https://dev.easebuzz.in/online-payment-gateway-India/",
    payment_link: "https://dev.easebuzz.in/payment-links/",
    wire: "https://dev.easebuzz.in/wire/",
    insta_collect: "https://dev.easebuzz.in/insta-collect",
    edu: "https://dev.easebuzz.in/feesbuzz/",
    smartbilling: "https://dev.easebuzz.in/smartbilling/",
    // loans: "https://dev.easebuzz.in/lending/",
    teller: "https://dev.easebuzz.in/teller/",
    smartx: "https://dev.easebuzz.in/smartx-expense-management/"
  },
  local: {
    pg: "https://dev.easebuzz.in/online-payment-gateway-India/",
    payment_link: "https://dev.easebuzz.in/payment-links/",
    wire: "https://dev.easebuzz.in/wire/",
    insta_collect: "https://dev.easebuzz.in/insta-collect",
    edu: "https://dev.easebuzz.in/feesbuzz/",
    smartbilling: "https://dev.easebuzz.in/smartbilling/",
    // loans: "https://dev.easebuzz.in/lending/",
    teller: "https://dev.easebuzz.in/teller/",
    smartx: "https://dev.easebuzz.in/smartx-expense-management/",
    drs:"https://drs.easebuzz.dev/api/v1/internal/authentications/generate_token/"
  }
}

export const primaryMenu = (merchantData, redirectURL) => {

  const wireSecondaryMenu = [{
    groupList: [
      {
        label: "Dashboard",
        Icon: faChartBar,
        to: "/dashboard",
        show: true,
      },
    ],
  },
  {
    groupName: "Payout",
    show: true,
    groupList: [
      {
        label: "Contacts",
        Icon: faAddressCard,
        to: "/contacts",
        show: true,
      },
      {
        label: "Transfers",
        Icon: faRupeeSign,
        to: "/transfers",
        show: true,
      },
      {
        label: "Vendor Payouts",
        Icon: faUserClock,
        to: "/vendor-payout",
        show: merchantData.evp,
        children: [{
          label: "Manage Vendors",
          Icon: faUserPlus,
          to: "manage",
          show: merchantData.evp,
        }, {
          label: "Invoices",
          Icon: faFileInvoice,
          to: "invoices",
          show: merchantData.evp
        },
          // {
          //   label: "Approvals",
          //   Icon: faFileInvoice,
          //   to: "approvals",
          //   show: merchantData.evp
          // }
        ]
      },
      {
        label: "Account Statements",
        Icon: faFileAlt,
        to: "/ledger",
        show: true,
      },
      {
        label: "Payout Links",
        Icon: faLink,
        to: "/payout-links",
        show: merchantData.epl,
      },
      {
        label: "Tally Invoices",
        Icon: faFileInvoice,
        to: "/tally-invoices",
        show: merchantData.etiv,
      },
    ],
  },
  {
    show: merchantData.esc && !isEmpty(merchantData.smart_collect_virtual_account),
    groupName: "Collection",
    groupList: [
      {
        label: "InstaCollect",
        Icon: faUniversity,
        to: "/insta-collect",
        show:
          merchantData.esc &&
          !isEmpty(merchantData.smart_collect_virtual_account),
      },
      {
        label: "Disputes",
        CustomIcon: chatIcon,
        extraCustomIcon: redirectIcon,
        to: "disputes",
        onClick: {redirectURL},
        show: merchantData.esc && !merchantData.is_submerchant && !isEmpty(merchantData.smart_collect_virtual_account) &&  get(merchantData,'user.permissions',[]).includes('IC_DISPUTE_READ'),
      }
    ],
  },
  {
    show: merchantData.gtp || merchantData.tdtp,
    groupName: "Tax Payments",
    groupList: [
      {
        label: "GST Payment",
        Icon: faCalculator,
        to: "/tax-payments/gst",
        show: merchantData.gtp,
      },
      {
        label: "Direct Tax Payment",
        Icon: faCalculator,
        to: "/tax-payments/direct_tax",
        show: merchantData.tdtp,
      }
    ],
  },
  {
    show: true,
    groupName: "Utilities",
    groupList: [
      {
        label: "Bulk Operations",
        Icon: faListAlt,
        to: "/batches",
        show: true,
      },
      {
        label: "Verifications",
        Icon: faCheckDouble,
        to: "/utility-requests",
        show: get(merchantData,'user.permissions',[]).includes('VIEW_VERIFICATIONS'),
      },
      {
        label: "Merchants",
        Icon: faSitemap,
        to: "/merchants",
        show: merchantData.is_reseller,
      },
      {
        label: "Reports",
        Icon: faFileExcel,
        to: "/reports",
        show: true,
      },
    ],
  }];

  const menu = [
    {
      enabled: (merchantData.allowed_products || {}).pg,
      label: "Payment Gateway",
      Icon: (merchantData.allowed_products || {}).pg ? PGIcon : disabledPGIcon,
      to: (merchantData.allowed_products || {}).pg ? PRODUCT_URLS[merchantData.env || 'dev'].pg : PAGE_URLS[merchantData.env || 'dev'].pg,

    },
    {
      enabled: (merchantData.allowed_products || {}).payment_link,
      label: "Payment Link",
      Icon: (merchantData.allowed_products || {}).payment_link ? PLIcon : disabledPLIcon,
      to: (merchantData.allowed_products || {}).payment_link ? PRODUCT_URLS[merchantData.env || 'dev'].payment_link : PAGE_URLS[merchantData.env || 'dev'].payment_link,

    },
    {
      enabled: (merchantData.allowed_products || {}).wire,
      label: "Wire",
      Icon: (merchantData.allowed_products || {}).wire ? WireIcon : disabledWireIcon,
      to: (merchantData.allowed_products || {}).wire ? PRODUCT_URLS[merchantData.env || 'dev'].wire : PAGE_URLS[merchantData.env || 'dev'].wire,
      secondaryMenu: wireSecondaryMenu
    },
    {
      enabled: (merchantData.allowed_products || {}).insta_collect,
      label: "InstaCollect",
      Icon: (merchantData.allowed_products || {}).insta_collect ? InstaCollectIcon : disabledInstaCollectIcon,
      to: (merchantData.allowed_products || {}).insta_collect ? PRODUCT_URLS[merchantData.env || 'dev'].insta_collect : PAGE_URLS[merchantData.env || 'dev'].insta_collect,
      secondaryMenu: wireSecondaryMenu
    },
    {
      enabled: (merchantData.allowed_products || {}).smart_billing,
      label: "Smart Billing",
      Icon: (merchantData.allowed_products || {}).smart_billing ? SmartBillingIcon : disabledSmartBillingIcon,
      to: (merchantData.allowed_products || {}).smart_billing ? PRODUCT_URLS[merchantData.env || 'dev'].smartbilling : PAGE_URLS[merchantData.env || 'dev'].smartbilling,
    },
    // {
    //   enabled: (merchantData.allowed_products || {}).capital,
    //   label: "Loans",
    //   Icon: (merchantData.allowed_products || {}).capital ? LoansIcon : disabledLoansIcon,
    //   to: (merchantData.allowed_products || {}).capital ? PRODUCT_URLS[merchantData.env || 'dev'].loans : PAGE_URLS[merchantData.env || 'dev'].loans,
    // },
    {
      enabled: (merchantData.allowed_products || {}).teller,
      label: "Teller",
      Icon: (merchantData.allowed_products || {}).teller ? TellerIcon : disabledTellerIcon,
      to: (merchantData.allowed_products || {}).teller ? PRODUCT_URLS[merchantData.env || 'dev'].teller : PAGE_URLS[merchantData.env || 'dev'].teller,
    },
    {
      enabled: (merchantData.allowed_products || {}).edu_allowed,
      label: "Forms and Fees",
      Icon: (merchantData.allowed_products || {}).edu_allowed ? EduIcon : disabledEduIcon,
      to: (merchantData.allowed_products || {}).edu_allowed ? PRODUCT_URLS[merchantData.env || 'dev'].edu : PAGE_URLS[merchantData.env || 'dev'].edu,
    },
    {
      enabled: (merchantData.allowed_products || {}).smartx_allowed,
      label: "SmartX",
      Icon: (merchantData.allowed_products || {}).smartx_allowed ? SmartXIcon : disabledSmartXIcon,
      to: (merchantData.allowed_products || {}).smartx_allowed ? PRODUCT_URLS[merchantData.env || 'dev'].smartx : PAGE_URLS[merchantData.env || 'dev'].smartx,
    },
    {
      enabled: (merchantData.allowed_products || {}).app_store,
      label: "App Store",
      Icon: (merchantData.allowed_products || {}).app_store ? AppStoreIcon : disabledAppStoreIcon,
      to: (merchantData.allowed_products || {}).app_store ? PRODUCT_URLS[merchantData.env || 'dev'].appstore : '',
    },
  ];

  return menu;
};

